module.exports = __webpack_public_path__ + "static/media/equalicare-img15.1d8da6d3.png";